<div class="container m-0 mt-2">
  <div style="max-width: max-content; margin-left: auto;">
    <div style="display: inline-table; margin-right: 50px; margin-bottom: 10px;">
      <button (click)="createCopyTournament()" type="button" class="btn btn-sm btn-copy" id="btn-copy">Создать копию турнира</button>
      <div
        *ngIf="checkCopyError()"
        class="text-danger extraErrorsStyles"
      >
        {{ checkCopyError() }}
      </div>
      <div
        *ngIf="checkCopySuccess()"
      >
        <a href="/tournament/{{ newTournamentId }}/info" class="link-success">{{ checkCopySuccess() }}</a>
      </div>
    </div>
    <div style="display: inline-table;">
      <select class="form-control form-control-status" (change)="assignStatus($event)" id="status-select" style="outline: none">
        <option *ngFor="let status of get_available_statuses()" [selected]="tournamentStatus == status" [value]="status">{{ get_status_name(status) }}</option>
      </select>
      <div
        *ngIf="checkStatusError()"
        class="text-danger extraErrorsStyles"
      >
        {{ checkStatusError() }}
      </div>
    </div>
  </div>
</div>
